import { Route } from '@angular/router';
import { RenderMode, ServerRoute } from '@angular/ssr';

export const paymentReturnRouteServer: ServerRoute = {
  path: 'payment/return',
  renderMode: RenderMode.Client,
};

export const paymentReturnRouteClient: Route = {
  path: 'payment/return',
  pathMatch: 'full',
  loadComponent: () =>
    import('../../pages/payment-return/payment-return.component').then(
      (c) => c.PaymentReturnComponent
    ),
};
